import { useEffect, useState } from 'react';
import api from '../api/endpoints';
import { fileUrl } from '../api/client';

const SEEN_KEY = 'kaamwala.splash.seen';

/**
 * The same launch screen the app shows, once per visit on the web: the brand
 * lockup, or whatever festival design admin has put live. It never blocks the
 * site - it fades out on its own.
 */
const SplashGate = ({ children }) => {
  const [splash, setSplash] = useState(null);
  const [phase, setPhase] = useState(() => {
    try { return sessionStorage.getItem(SEEN_KEY) ? 'done' : 'show'; } catch (e) { return 'show'; }
  });

  useEffect(() => {
    if (phase !== 'show') return undefined;
    let hold = null;
    let alive = true;
    const close = (ms) => {
      hold = setTimeout(() => {
        if (!alive) return;
        setPhase('fade');
        setTimeout(() => alive && setPhase('done'), 350);
      }, ms);
    };
    api.splash.current({ audience: 'user' })
      .then((r) => {
        const next = r.data || null;
        if (alive && next) setSplash(next);
        close(Math.min(Math.max((next && next.durationMs) || 1600, 800), 8000));
      })
      .catch(() => close(1200));
    try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) { /* private mode */ }
    return () => { alive = false; if (hold) clearTimeout(hold); };
  }, [phase]);

  if (phase === 'done') return children;

  const art = splash && splash.media ? fileUrl(splash.media) : null;
  return (
    <>
      {children}
      <div
        className={`splash-gate ${phase === 'fade' ? 'fade' : ''}`}
        style={{ background: (splash && splash.backgroundColor) || '#fff' }}
      >
        {art ? (
          splash.mediaType === 'video' ? (
            <video src={art} autoPlay muted loop playsInline style={{ objectFit: splash.fit || 'cover' }} />
          ) : (
            <img src={art} alt="" style={{ objectFit: splash.fit || 'cover' }} />
          )
        ) : (
          <img src={`${process.env.PUBLIC_URL}/logo-full.png`} alt="Kaam Wala" className="splash-lockup" />
        )}
        {splash && splash.tagline ? (
          <div className="splash-tagline" style={{ color: splash.taglineColor || '#fff' }}>{splash.tagline}</div>
        ) : null}
      </div>
    </>
  );
};

export default SplashGate;
